import React, { useState } from 'react';
import { useManagerTheme } from '../context/ManagerThemeContext';
import ManagerTransferModal from './ManagerTransferModal';

interface ManagerHeaderProps {
  onRefresh?: () => void;
  onCreditMoney?: () => void;
  onMyProfile?: () => void;
  onLogout?: () => void;
  onTransferMoney?: () => void;
  showCreditModal?: boolean;
  setShowCreditModal?: (show: boolean) => void;
  user?: {
    name?: string;
    role?: string;
  } | null;
}

const ManagerHeader: React.FC<ManagerHeaderProps> = ({
  onRefresh,
  onCreditMoney,
  onMyProfile,
  onLogout,
  user,
}) => {
  const { headerColor } = useManagerTheme();
  const [showTransferModal, setShowTransferModal] = useState(false);

  const handleTransferMoney = () => setShowTransferModal(true);
  const handleTransferSuccess = () => onRefresh?.();

  const btnSecondary =
    'flex items-center gap-2 py-2.5 px-4 rounded-lg text-sm font-medium min-h-[40px] border border-slate-600 bg-slate-800/80 text-slate-200 hover:bg-slate-700 hover:border-slate-500 hover:text-white transition-colors focus:outline-2 focus:outline-offset-2 focus:outline-slate-500';
  const btnLogout =
    'flex items-center gap-2 py-2.5 px-4 rounded-lg text-sm font-medium min-h-[40px] border border-red-900/60 bg-red-500/20 text-red-300 hover:bg-red-500/30 hover:border-red-500/80 transition-colors focus:outline-2 focus:outline-offset-2 focus:outline-red-500';

  return (
    <header className="h-16 min-h-[64px] flex justify-between items-center px-6 py-0 w-full m-0 box-border border-b border-slate-800 md:px-5 sm:px-4" style={{ backgroundColor: headerColor }}>
      <div className="flex-shrink-0 mr-8 md:mr-6 sm:mr-0">
        <img
          src={`${process.env.PUBLIC_URL || ''}/logo.png`}
          alt="Logo"
          className="w-[200px] h-auto object-contain"
        />
      </div>
      <div className="flex-1" />
      <div className="hidden md:flex items-center gap-3 md:gap-2">
        <button type="button" className={btnSecondary} onClick={handleTransferMoney}>
          <span>💰</span> Send Coins
        </button>
        <button type="button" className={`${btnSecondary} border-emerald-600/60 bg-emerald-500/10 text-emerald-300 hover:bg-emerald-500/20 hover:border-emerald-500/80`} onClick={onCreditMoney}>
          <span>💳</span> Credit Money
        </button>
        <button type="button" className={btnSecondary} onClick={onMyProfile}>
          <span>👤</span> My Profile
        </button>
        <button type="button" className={btnLogout} onClick={onLogout}>
          <span>🚪</span> Logout
        </button>
      </div>

      <ManagerTransferModal
        isOpen={showTransferModal}
        onClose={() => setShowTransferModal(false)}
        onTransferSuccess={handleTransferSuccess}
      />
    </header>
  );
};

export default ManagerHeader;
